<template>
    <div>
        <Modal v-model="$parent.tempoListDialog" :mask-closable="false" width="700">
            <div slot="header"><strong>Tempo ({{tempoArr.length}})</strong>
                <Icon type="md-add-circle" style="float: right" size="22" @click="onAddTempo()"></Icon>
            </div>
            <div>
                <Table :columns="tempoHeaders" :data="tempoArr" max-height="400"
                       :loading="$apollo.queries.tempo.loading" v-if="$parent.tempoListDialog">
                  <template slot-scope="{ row }" slot="type"><span>{{TempoTypesJson[row.type] || '-'}}</span></template>
                    <template slot-scope="{ row }" slot="action">
                        <Icon type="md-create" @click="onEditTempo(row)"></Icon>&nbsp;
                        <Icon type="md-close" @click="onDeleteTempo(row.id)"></Icon>
                    </template>
                </Table>
            </div>
            <div slot="footer">
                <Button style="background: #999999; color: white;font-weight: bolder" @click="$parent.tempoListDialog=false">CLOSE</Button>
            </div>
        </Modal>

        <Modal v-model="addTempoDialog" :mask-closable="false" draggable width="600">
            <div slot="header"><strong>{{editMode?'Edit':'New'}} Tempo</strong></div>
            <div class="modal-content">
                <Form :model="tempoForm" :rules="ruleTempoForm" ref="tempoForm" :label-width="110">
              <!--      <FormItem prop="name" label="Name">
                        <Input v-model="tempoForm.name"/>
                    </FormItem>                                             -->
                    <FormItem prop="contractorName" label="Contractor">
                        <Select v-model="tempoForm.contractorName" filterable>
                            <Option v-for="contractor in contractorArr" :value="contractor.name"
                                    :label="contractor.name" :key="contractor.id">
                                <div class="ivu-select-item-div" @click="tempoForm.contractorId=contractor.id"> {{contractor.name}}
                                    <span style="float: right;color:#C0C0C0">{{contractor.contractorCode}}</span></div>
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="Status" prop="status">
                      <RadioGroup v-model="tempoForm.status">
                        <Radio label="Active"><span>Active</span></Radio>
                        <Radio label="Inactive"><span>Inactive</span></Radio>
                      </RadioGroup>
                    </FormItem>

                    <FormItem prop="type" label="Type">
                      <Select v-model="tempoForm.type" filterable class="tempo-type">
                        <Option v-for="type in TempoTypes" :label="type.label" :value="type.value" :key="type.value"/>
                      </Select>
                    </FormItem>

                  <FormItem prop="plateNumber" label="Plate Number">
                        <Input v-model="tempoForm.plateNumber"/>
                    </FormItem>

                    <FormItem prop="capacity" label="Capacity">
                        <Input v-model="tempoForm.capacity" type="number"/>
                    </FormItem>


                    <FormItem prop="kmLimit" label="KM Limit">
                        <Input v-model="tempoForm.kmLimit" type="number"/>
                    </FormItem>


                    <FormItem prop="city" label="Select City">
                        <AutoComplete v-model="tempoForm.city" v-if="addTempoDialog" @on-search="handleCitySearch">
                            <Option v-for="(cityObj,index) in cityArr" :label="cityObj.city"
                                    :key="index" :value="cityObj.city">
                                <div class="ivu-select-item-div">{{cityObj.city}}</div>
                            </Option>
                        </AutoComplete>
                    </FormItem>
                    <FormItem prop="hiringPrice" label="Hiring price">
                        <Input v-model="tempoForm.hiringPrice" type="number"/>
                    </FormItem>
                    <FormItem prop="extraKmPrice" label="Extra KM Limit">
                        <Input v-model="tempoForm.extraKmPrice" type="number"/>
                    </FormItem>
                </Form>
            </div>
            <div slot="footer">
                <Button v-if="!editMode" type="primary" style="font-weight: bolder" @click="addTempo" :loading="loading">
                    <span v-if="!loading">SAVE</span>
                    <span v-else>Loading...</span>
                </Button>
                <Button v-if="editMode" type="primary" style="font-weight: bolder" @click="modifyTempo">UPDATE</Button>
                <Button style="background: #999999; color: white;font-weight: bolder" @click="addTempoDialog=false">CANCEL</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {ADD_TEMPO, UPDATE_TEMPO, DELETE_TEMPO} from '../../graphql/mutations/vehicle'
    import { GET_TEMPOS} from '../../graphql/queries/vehicle'
    import { SUBSCRIBE_TEMPOS} from '../../graphql/subscription/vehicle'
    import { SEARCH_CITY2} from '../../graphql/queries/territories'
    import {GET_CONTRACTORS} from '../../graphql/queries/vehicle'
    import { SUBSCRIBE_CONTRACTORS} from '../../graphql/subscription/vehicle'
    import {convertArrToObj, generateUUID} from '../../Constants/Constant'
    import ValidationRules from '../../Constants/ValidationRules'
    import {TempoTypes} from "../../Constants/Constant";

    export default {
        apollo: {
            tempo: {
                query: GET_TEMPOS,
                subscribeToMore: {
                    document: SUBSCRIBE_TEMPOS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.tempoArr = subscriptionData.data.tempo;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.tempoArr = data.tempo;
                    }
                }
            },
            city: {
                query: SEARCH_CITY2,
                variables() {
                    return {
                        cityFilter: this.cityFilter
                    }
                },
                debounce: 500,
                skip: true,
                result ({ data, loading }) {
                    if (!loading) {
                        this.cityArr = data.city;
                    }
                }
            },
            contractor: {
                query: GET_CONTRACTORS,
                subscribeToMore: {
                    document: SUBSCRIBE_CONTRACTORS,
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.contractorArr = subscriptionData.data.contractor;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.contractorArr = data.contractor;
                    }
                }
            },
        },
        name: "Tempo",
        data: function(){
            return{
                mutation_ADD_TEMPO: ADD_TEMPO,
                mutation_UPDATE_TEMPO: UPDATE_TEMPO,
                mutation_DELETE_TEMPO: DELETE_TEMPO,
                tempoArr: [],
                tempoHeaders: [
                    // {title: 'Name', key: 'name'},
                    {title: 'Plate', key: 'platNo'},
                    {title: 'City', key: 'city'},
                    {title: 'Capacity', key: 'capacity'},
                    {title: 'KM limit', key: 'kmLimit'},
                    {title: 'Type', slot: 'type'},
                    {title: ' ', slot: 'action', width: 80}
                ],
                cityArr: [],
                addTempoDialog: false,
                tempoForm:{
                    id: '',
                    name: '',
                    status: 'Active',
                    type: '',
                    contractorId:'',
                    contractorName:'',
                    plateNumber: '',
                    city: '',
                    capacity: '',
                    kmLimit: '',
                    extraKmPrice:'',
                    hiringPrice:''
                },
                ruleTempoForm:{
                    // name: ValidationRules.textField('Name'),
                    plateNumber: ValidationRules.textField('Plate Number'),
                    city: [{}],
                    capacity: ValidationRules.numberField,
                    kmLimit: ValidationRules.numberField,
                    extraKmPrice: ValidationRules.numberField,
                    hiringPrice: ValidationRules.numberField,
                    contractorName: ValidationRules.textField('Contractor'),
                    type: ValidationRules.textField('Type'),
                },
                contractorArr:[],
                editMode: false,
                cityFilter: '%%',
                loading: false,
                TempoTypes,
                TempoTypesJson: convertArrToObj(TempoTypes, 'value', 'label')
            }
        },
        methods: {
            handleCitySearch: function(val){
                this.cityFilter = '%' + val + '%';
                this.$apollo.queries.city.skip = false;
            },
            reset: function(){
                this.$refs['tempoForm'].resetFields();
            },
            onAddTempo(contractorData){
                this.reset();
                this.editMode = false;
                this.addTempoDialog = true;
            /* --- Assign/Autofill Contractor if loaded in contractors component ---- */
                if(contractorData){
                    this.tempoForm.contractorId = contractorData.id;
                    this.tempoForm.contractorName = contractorData.name;
                }
            /* -------x------------x-------------x--------------x--------------x----- */

            },
            addTempo(){
                this.loading = true;
                this.$refs['tempoForm'].validate((valid) => {
                    if (valid) {
                        this.insertTempo();
                    }else{
                        this.loading = false
                    }
                })
            },
            async insertTempo(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_TEMPO,
                    variables: {
                        id: generateUUID(),
                        name: this.tempoForm.name,
                        status: this.tempoForm.status === 'Active',
                        contractorId: this.tempoForm.contractorId,
                        platNo: this.tempoForm.plateNumber,
                        city: this.tempoForm.city,
                        capacity: this.tempoForm.capacity,
                        kmLimit: this.tempoForm.kmLimit,
                        hiringPrice: this.tempoForm.hiringPrice,
                        extraKmPrice: this.tempoForm.extraKmPrice,
                        type: this.tempoForm.type,
                    }
                })
                if(response.data.insert_tempo.returning[0].id){
                    this.$Message.success('New Tempo added successfully!');
                    this.reset();
                    this.loading = false
                    this.addTempoDialog = false;
                }
            },
            onEditTempo(tempoData){
                this.reset();
                this.tempoForm.id = tempoData.id;
                this.tempoForm.name = tempoData.name;
                this.tempoForm.status = tempoData.status?'Active':'Inactive';
                this.tempoForm.plateNumber = tempoData.platNo;
                this.tempoForm.city = tempoData.city;
                this.tempoForm.capacity = tempoData.capacity;
                this.tempoForm.kmLimit = tempoData.kmLimit;
                this.tempoForm.hiringPrice = tempoData.hiringPrice;
                this.tempoForm.extraKmPrice = tempoData.extraKmPrice;
                this.tempoForm.contractorId = tempoData.Contractor?.id;
                this.tempoForm.contractorName = tempoData.Contractor?.name;
                this.tempoForm.type = tempoData.type;
                this.editMode = true;
                this.addTempoDialog = true;
            },
            modifyTempo(){
                this.$refs['tempoForm'].validate((valid) => {
                    if (valid) {
                        this.updateTempo();
                    }
                })
            },
            async updateTempo(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_TEMPO,
                    variables: {
                        tempoId: this.tempoForm.id,
                        name: this.tempoForm.name,
                        status: this.tempoForm.status === 'Active',
                        contractorId: this.tempoForm.contractorId,
                        platNo: this.tempoForm.plateNumber,
                        city: this.tempoForm.city,
                        capacity: this.tempoForm.capacity,
                        kmLimit: this.tempoForm.kmLimit,
                        hiringPrice: this.tempoForm.hiringPrice,
                        extraKmPrice: this.tempoForm.extraKmPrice,
                        type: this.tempoForm.type,
                    }
                })
                if(response.data){
                    this.$Message.success('Tempo updated successfully!');
                    this.reset();
                    this.addTempoDialog = false;
                }
            },
            onDeleteTempo(tempoId){
                this.$Modal.confirm({
                    title: 'Confirmation',
                    content: '<p>Are You sure want to delete Tempo ?</p>',
                    loading: true,
                    onOk: () => {
                        this.deleteTempo(tempoId, this.$Modal)
                    }
                });
            },
            deleteTempo(tempoId, callback){
                this.$apollo.mutate({
                    mutation: this.mutation_DELETE_TEMPO,
                    variables: { tempoId: tempoId }
                }).then(function(response){
                    callback.remove();
                    this.$Message.success('Tempo deleted successfully!');
                }).catch(function(err){
                    callback.remove();
                })
            }
        }
    }
</script>

<style scoped>
    /deep/ .tempo-type .ivu-select-item{
      padding: 7px 16px;
    }
    /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
    /deep/ .ivu-auto-complete.ivu-select-dropdown{
        max-height: 200px !important;
    }
    /deep/ .ivu-modal-close{
        visibility: hidden;
    }
    /deep/ .code-uppercase > input{
        text-transform: uppercase;
    }
    /deep/ .ivu-table td {
        border-bottom: 0px;
        font-size: 14px;
    }
    /deep/ .ivu-table th {
        border-bottom: 0px;
        font-size: 14px;
        text-align: center;
    }
    /deep/ .ivu-table-wrapper {
        position: unset !important;
        border: 0px ;
    }
    /deep/ .ivu-table-cell {
        padding-left: 0px;
        padding-right: 0px;
        text-align: center;
    }
    .modal-content{
      max-height: 550px;
      overflow-y: scroll;
      padding: 0px 20px 0 0;
    }
    .modal-content::-webkit-scrollbar {
      width: 5px !important;
      height: 5px !important;
      display: block !important;
    }
    .modal-content::-webkit-scrollbar-thumb {
      background: #c1c1c1 !important;
      border-radius: 5px !important;
    }
</style>
